import React from "react";
import { defineMessages, useIntl } from "react-intl";
import compose from "recompose/compose";
import trackEvent from "theme/modules/Analytics/trackEvent";
import EnhanceAddToCart from "./EnhanceAddToCart";
import AddToCartMutation from "./AddToCartMutation.gql";
import OutOfStock from "./OutOfStock";
import NumberInput from "theme/components/atoms/Form/Input/NumberInput";
import FormItem from "theme/components/molecules/Form/Item";
import BaseAddToCart from "theme/modules/AddToCart/BaseAddToCart";

const messages = defineMessages({
  quantityLabel: {
    id: "modules.AddToCart.quantityLabel",
    defaultMessage: "Quantity",
  },
});

export const AddToCart = ({
  appearance,
  product,
  label,
  unavailableLabel,
  qty,
  disabled,
  actions,
  addToCart,
  commandPending,
  message,
}) => {
  const intl = useIntl();

  if (!product?.stock?.isInStock) {
    return (
      <OutOfStock
        message={message}
        unavailableLabel={unavailableLabel}
        sku={product?.sku}
      />
    );
  }

  return (
    <BaseAddToCart
      appearance={appearance}
      product={product}
      addToCart={({ quantity }) =>
        addToCart({ qty: typeof qty === "number" ? qty : quantity })
      }
      message={message}
      state={commandPending ? "pending" : disabled ? "disabled" : undefined}
      label={label}
      quantity={
        typeof qty !== "number" && (
          <FormItem label={intl.formatMessage(messages.quantityLabel)}>
            <NumberInput
              name="quantity"
              id="quantity"
              value={1}
              disabled={commandPending}
            />
          </FormItem>
        )
      }
      actions={actions}
    />
  );
};

export default compose(
  EnhanceAddToCart({
    AddToCartMutation,
    addToCartCallback:
      ({ onProductAdded, product }, variables) =>
      ({ status, data }) => {
        if (status === "success") {
          const finalPrice = product?.prices?.finalPrice?.priceInclTax?.value;
          trackEvent("Product Added", {
            sku: product.sku,
            name: product.name,
            price: finalPrice?.amount,
            currency: finalPrice?.currency,
            qty: variables?.qty,
          });
          onProductAdded();
        }
      },
  })
)(AddToCart);
